import React, { useState, useEffect } from "react";
import { ItemsByResponsable } from "./ItemsByResponsable";
import { CircularItems } from "./CircularItems";
import { filterData } from "../../api/common";
import { todayColombia } from "../../utils/fechasColombia";

export function ChartDate() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dataItem, setDataItem] =useState()
  const [dataOtEstados, setDataOtEstados] =useState()

  console.log("dataitem: ",dataItem)
  console.log("dataOtEstados: ",dataOtEstados)
  useEffect(() => {
    const today = todayColombia();
    const lastMonthDate = new Date(Date.now() - 5 * 60 * 60 * 1000);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
    const formattedLastMonth = lastMonthDate.toISOString().slice(0, 10);

    setStartDate(formattedLastMonth);
    setEndDate(today);
     fetchData();
  }, []);


    const fetchData = async () => {
        console.log("ejecutando primera consulta: ",startDate," ",endDate)
      if (!startDate || !endDate) return;

      try {
        const res = await filterData('dashboard',{
          fechaInicio:startDate,
          fechaFin: endDate
        });
    
        console.log(res.data)
        setDataItem(res.data.itemsByMagnitud)
        setDataOtEstados(res.data.AllOtByDateEstado)

     }catch{
        console.log("error")
     }
    }

      useEffect(() => {
        fetchData();
      }, [startDate, endDate]);

  return (
    <div>
      {/* RANGO GENERAL DE FECHAS ✅ */}
      <div style={{ display: "flex", gap: "1rem", margin: "1rem" }}>
        <div>
          <label>Desde: </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div>
          <label>Hasta: </label>

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>

      {/* HIJOS QUE CONSUMEN ESTAS FECHAS ✅ */}
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        <CircularItems data={dataItem} endDate={endDate} startDate={startDate} title={"Ítems Creados"}/>
        <CircularItems data={dataOtEstados} endDate={endDate} startDate={startDate} title={"Estado Ordenes"}/>
        <ItemsByResponsable startDate={startDate} endDate={endDate} />
        </div>
    </div>
  );
}
